/* eslint-disable react-hooks/exhaustive-deps */

import React, { useLayoutEffect, useState } from "react";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import {
  Layout,
  Card,
  Row,
  Col,
  Statistic,
  Tag,
  Table,
  Spin,
  Progress,
  Divider,
} from "antd";

import { useParams } from "react-router-dom";

import { getAPI } from "../../utils/common";

import { SMART_PRICE } from "../../constants/api";

function SmartPriceRoomDetail() {
  const { Content } = Layout;

  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const [detail, setDetail] = useState({});

  const [comparison, setComparison] = useState({});

  const [signals, setSignals] = useState({});

  useLayoutEffect(() => {
    getRoomDetail();

    getComparison();

    getSignals();
  }, []);

  const getRoomDetail = () => {
    setLoading(true);

    getAPI(
      SMART_PRICE + "/room/" + id,

      (res) => {
        if (res.status === true) {
          setDetail(res.data);
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  const getComparison = () => {
    getAPI(
      SMART_PRICE + "/room/" + id + "/comparison",

      (res) => {
        if (res.status === true) {
          setComparison(res.data);
        }
      },

      () => {},

      {},
    );
  };

  const getSignals = () => {
    getAPI(
      SMART_PRICE + "/signal-analysis/" + id,

      (res) => {
        if (res.status === true) {
          setSignals(res.data);
        }
      },

      () => {},

      {},
    );
  };

  const historyColumns = [
    {
      title: "Date",
      dataIndex: "effective_date",
    },

    {
      title: "Old Price",
      dataIndex: "old_price",

      render: (value) => `₹ ${value}`,
    },

    {
      title: "New Price",
      dataIndex: "new_price",

      render: (value) => `₹ ${value}`,
    },

    {
      title: "Type",
      dataIndex: "change_type",

      render: (value) => <Tag>{value}</Tag>,
    },

    {
      title: "Reason",
      dataIndex: "reason",
    },
  ];

  const renderSignals = (items, color) => {
    if (!items || items.length === 0) {
      return <p>No Data</p>;
    }

    return items.map((item, index) => (
      <Card
        key={index}
        size="small"
        style={{
          marginBottom: 10,
        }}
      >
        <Tag color={color}>{item.factor}</Tag>

        <p>{item.reason}</p>

        <b>Score : {item.score}</b>
      </Card>
    ));
  };

  let score = detail.score || 0;

  let progressValue = Math.abs(score);

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title={`${detail.room_name || "Room"} Pricing Analysis`}
          bordered={false}
        >
          <Spin spinning={loading}>
            <Row gutter={[16, 16]}>
              <Col span={6}>
                <Card>
                  <Statistic
                    title="Current Price"
                    value={detail.current_price || 0}
                    prefix="₹"
                  />
                </Card>
              </Col>

              <Col span={6}>
                <Card>
                  <Statistic
                    title="Suggested Price"
                    value={detail.suggested_price || 0}
                    prefix="₹"
                  />
                </Card>
              </Col>

              <Col span={6}>
                <Card>
                  <Statistic
                    title="Change Percentage"
                    value={detail.change_percentage || 0}
                    suffix="%"
                  />
                </Card>
              </Col>

              <Col span={6}>
                <Card>
                  <Statistic
                    title="Demand Level"
                    value={detail.demand_level || "-"}
                  />
                </Card>
              </Col>
            </Row>

            <Divider />

            <Card title="AI Demand Score">
              <Progress
                percent={progressValue > 100 ? 100 : progressValue}
                status={score >= 0 ? "success" : "exception"}
              />

              <Tag color={score >= 0 ? "green" : "red"}>Score : {score}</Tag>
            </Card>

            <Divider />

            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Card title="Positive Factors">
                  {renderSignals(
                    signals.positive_factors,

                    "green",
                  )}
                </Card>
              </Col>

              <Col span={12}>
                <Card title="Negative Factors">
                  {renderSignals(
                    signals.negative_factors,

                    "red",
                  )}
                </Card>
              </Col>
            </Row>

            <Divider />

            <Card title="Price Change History">
              <Table
                columns={historyColumns}
                dataSource={comparison.history || []}
                pagination={false}
                rowKey={(row, index) => index}
              />
            </Card>
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default SmartPriceRoomDetail;
